module.exports = __webpack_public_path__ + "media/Dimmer.0cfc4dee.wav";